import React from 'react'
import moment from 'moment';
import { Modal, ModalFooter, ModalHeader, ModalContent, Button, CopyButton } from "@netapp/bxp-design-system-react";
import styles from "./HttpsModal.module.scss";
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { connectorsettings as i18nNamespace } from "../../../../i18n/namespace";
import { useSelector } from 'react-redux';

export const CsrModal = ({ csr, closeTrigger }) => {
    const { t } = useTranslation(i18nNamespace);
    return <Modal className={styles["modal"]} closeTrigger={closeTrigger}>
        <ModalHeader>
            {t("submit_CA_certificate")}
        </ModalHeader>
        <ModalContent>
            {csr}
        </ModalContent>
        <ModalFooter>
            <CopyButton variant="square" text={csr}>{t("copy_csr")}</CopyButton>
            <Button color="secondary"
                onClick={closeTrigger}>{t("close")}</Button>
        </ModalFooter>
    </Modal>
};

export const PromptModal = ({ header, msg, closeTrigger, generateCsr }) => {
    const { t } = useTranslation(i18nNamespace);
    return <Modal className={styles["modal"]} closeTrigger={closeTrigger}>
        <ModalHeader>
            {t("regenerate_new_csr")}
        </ModalHeader>
        <ModalContent>
            {msg}
        </ModalContent>
        <ModalFooter>
            <Button onClick={generateCsr}>{t("generate")}</Button>
            <Button color="secondary"
                onClick={closeTrigger}>{t("close")}</Button>
        </ModalFooter>
    </Modal>
};

// The agent-tls-certificate API returns certificate metadata only, never the
// PEM body, so the details below are everything that can be shown.
export const ViewSignedCertificate = ({ closeTrigger, certificate }) => {
    const { t } = useTranslation(i18nNamespace);
    const fallback = t("not_available");
    const formatDate = date => date ? moment(date).format(t("certificate_detail_date_format")) : fallback;
    const isPem = typeof certificate === "string";

    const certificateFields = [
        {label: t("certificate_subject"), value: certificate?.subjectName || fallback},
        {label: t("certificate_issuer"), value: certificate?.directIssuerName || fallback},
        {label: t("certificate_valid_from"), value: formatDate(certificate?.startDate)},
        {label: t("certificate_valid_to"), value: formatDate(certificate?.endDate)},
        {label: t("certificate_serial_number"), value: certificate?.serialNumber || fallback},
        {label: t("certificate_alternative_names"), value: certificate?.alternativeNames || fallback}
    ];

    return <Modal closeTrigger={closeTrigger}>
        <ModalHeader>
            {t("bluexp_connector_certificate")}
        </ModalHeader>
        <ModalContent style={isPem ? { overflowWrap: "break-word" } : undefined}>
            {isPem ? certificate : (
                <div className={styles["certificate-grid"]}>
                    {certificateFields.map(({label, value}) => <React.Fragment key={label}>
                        <div>{label}</div>
                        <div>{value}</div>
                    </React.Fragment>)}
                </div>
            )}
        </ModalContent>
        <ModalFooter>
            <Button onClick={closeTrigger}>{t("close")}</Button>
        </ModalFooter>
    </Modal>
};

export const ChangeExistingModal = ({ closeTrigger }) => {
    const { t } = useTranslation(i18nNamespace);
    const agentId = useSelector(state => state.tenancy.selectedAgentId);

    return <Modal className={styles["modal"]} closeTrigger={closeTrigger}>
        <ModalHeader>
            {t("change_certificate")}
        </ModalHeader>
        <ModalContent>
            {t("certificate_change_confirmation")}
        </ModalContent>
        <ModalFooter>
            <NavLink to={`/agents-mgmt/${agentId}/https-setup`}>
                <Button>{t("ok")}</Button>
            </NavLink>
            <Button color="secondary"
                onClick={closeTrigger}>{t("close")}</Button>
        </ModalFooter>
    </Modal>
};